import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Button, Link, Divider } from '@mui/material';
import { coachProfileService } from '../../services';
import Icon from './Icon';
import Feedback from './Feedback';
import Disclaimer from './Disclaimer';

const MAX_LENGTH = 400; // Number of characters before truncation

const ContentSummaryView = ({
    title,
    titleStyle,
    icon,
    iconStyle = { color: 'orange', size: 20 },
    externalSummary,
    promptOptions,
    summaryStyle,
    containerStyle,
    feedback = true,
    onLike,
    onDislike,
    showMoreButton = false,
    showMoreButtonOnPress,
    loaderStyle = { color: 'black', size: 'small' },
    showMoreStyle,
    showMore,
    showLess,
    onSummaryResponse,
    disclaimer = true,
    disclaimerText,
    clickableText,
    onPress,
    disclaimerStyle,
    dividerStyle,
}) => {
    const [loading, setLoading] = useState(true);
    const [summary, setSummary] = useState('');
    const [expanded, setExpanded] = useState(false);
    const [prevPromptOptions, setPrevOptions] = useState(null);

    const getSummary = async (promptOptions) => {

        try {
            setLoading(true);
            const s = await coachProfileService.getCoachProfileInsight(promptOptions.username || "")
            setSummary(s);
            // Call the callback and pass the values to parent
            onSummaryResponse?.(s);
            setLoading(false);
        } catch (error) {
            console.error('Error during fetch:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        const currentOptions = JSON.stringify(promptOptions);

        if(externalSummary) {
            setSummary(externalSummary);
            onSummaryResponse?.(externalSummary);
            setLoading(false);
        }
        else if (promptOptions && currentOptions !== prevPromptOptions) {
            setPrevOptions(currentOptions);
            getSummary(promptOptions);
            console.log('Fetching summary.....');
        }
    }, [externalSummary, promptOptions, prevPromptOptions]);

    const onExpandButton = () => {
        setExpanded(!expanded)
        showMoreButtonOnPress?.(!expanded);
    }

    return (
        <>{
            (summary && summary !== 'False' && summary !== '-False' && !loading) ? (
                <Box sx={{
                    ...containerStyle,
                    border: '1px solid gray',
                    borderRadius: 3,
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    overflow: 'hidden'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {icon && (
                            <Box sx={{ mr: 1 }}>
                                <Icon icon={icon} size={iconStyle.size} color={iconStyle.color} />
                            </Box>
                        )}
                        {title && <Typography variant="h6" style={{ ...titleStyle }}>{title}</Typography>}
                    </Box>

                    {loading ? (
                        <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress size={20} color="#ffffff" />
                        </Box>
                    ) : (
                        <>
                            <Typography style={{ marginTop: 1, ...summaryStyle }}>
                                {expanded ? summary : `${summary.slice(0, MAX_LENGTH)}...`}
                            </Typography>
                            {((summary.length > MAX_LENGTH) && (showMoreButton)) && (
                                <div style={{ textAlign: 'right', marginTop: 8 }}>
                                    <Button
                                        onClick={() => onExpandButton()}
                                        size="small"
                                        style={{
                                            minWidth: 'auto',
                                            width: 'auto',
                                            display: 'inline-block',
                                            textTransform: 'none',
                                            padding: '2px 6px',
                                            fontWeight: 'bold',
                                            color: '#FFFFFF', ...showMoreStyle
                                        }}
                                    >
                                        {expanded ? showLess : showMore}
                                    </Button>
                                </div>
                            )}
                        </>
                    )}

                    {/* Added "See a mistake? Let us know" section */}
                    {/* <Divider style={{ marginTop: 8, backgroundColor: 'gray' }} />

                     <Box sx={{ mt: 1, textAlign: 'left' }}>
                        <Typography variant="body2" style={{ color: 'darkgray' }}>
                            See a mistake?{' '}
                            <Link href="#" style={{ fontWeight: 'bold', cursor: 'pointer', color: '#FFFFFF' }}>
                                Let us know.
                            </Link>
                        </Typography>
                    </Box> */}

                    {feedback && <Feedback onLike={onLike} onDislike={onDislike} />}

                    {disclaimer && summary && (
                        <Disclaimer
                            disclaimerText={disclaimerText}
                            clickableText={clickableText}
                            onPress={() => onPress()}
                            style={disclaimerStyle}
                            dividerStyle={dividerStyle}
                        />
                    )}
                </Box>
            ) : null
        }</>
    );
};

export default ContentSummaryView;
